import { Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
// import { BarcodeFormat } from '@zxing/library';
import { Router } from '@angular/router';
import { LocaleService } from '@shared/services/locale.service';
import { Location } from '@angular/common';

@Component({
	selector: 'app-barcode-scanner',
	templateUrl: './barcode-scanner.component.html',
	styleUrls: ['./barcode-scanner.component.scss'],
})
export class BarcodeScannerComponent {
	availableDevices: MediaDeviceInfo[];
	currentDevice: MediaDeviceInfo = null;

	// formatsEnabled: BarcodeFormat[] = [BarcodeFormat.CODE_128, BarcodeFormat.DATA_MATRIX, BarcodeFormat.EAN_13, BarcodeFormat.QR_CODE];

	hasDevices: boolean;
	hasPermission: boolean;

	qrResultString: string;

	torchEnabled = false;
	torchAvailable$ = new BehaviorSubject<boolean>(false);
	tryHarder = false;

	constructor(private router: Router, public locale: LocaleService, public location: Location) {}

	clearResult(): void {
		this.qrResultString = null;
	}

	onCamerasFound(devices: MediaDeviceInfo[]): void {
		this.availableDevices = devices;
		this.hasDevices = Boolean(devices && devices.length);
	}

	onCodeResult(url: string) {
		this.qrResultString = url;
		let urlArray = url.split('/');
		const id = urlArray[urlArray.length - 1];
		this.router.navigate([`ad/${id}`]);
	}

	onDeviceSelectChange(selected: string) {
		const device = this.availableDevices.find((x) => x.deviceId === selected);
		this.currentDevice = device || null;
	}

	onHasPermission(has: boolean) {
		this.hasPermission = has;
	}

	onTorchCompatible(isCompatible: boolean): void {
		this.torchAvailable$.next(isCompatible || false);
	}

	toggleTorch(): void {
		this.torchEnabled = !this.torchEnabled;
	}

	toggleTryHarder(): void {
		this.tryHarder = !this.tryHarder;
	}
}
